var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.5 15C2.5 21.9036 8.09644 27.5 15 27.5C21.9036 27.5 27.5 21.9036 27.5 15C27.5 8.09644 21.9036 2.5 15 2.5C8.09644 2.5 2.5 8.09644 2.5 15Z",
    fill: "#095228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6498 13.4266C9.6498 13.1891 9.73731 12.9516 9.92481 12.7641C10.2873 12.4016 10.8873 12.4016 11.2498 12.7641L14.9998 16.5141L18.7498 12.7641C19.1123 12.4016 19.7123 12.4016 20.0748 12.7641C20.4373 13.1266 20.4373 13.7266 20.0748 14.0891L15.6623 18.5016C15.2998 18.8641 14.6998 18.8641 14.3373 18.5016L9.92481 14.0891C9.73731 13.9016 9.6498 13.6641 9.6498 13.4266Z",
    fill: "#095228"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize);
export default __webpack_public_path__ + "static/media/maximize.1270f4cd691fa0b6b0491f363edbe816.svg";
export { ForwardRef as ReactComponent };